import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { ConfigProvider, applyBrand } from "@/context/ConfigContext";
import Landing from "@/pages/Landing";
import SiteStatus from "@/components/site/SiteStatus";

const STATUS = { 404: "unknown", 403: "inactive" };

export default function SchoolSite({ slug, school: preloaded }) {
  const [school, setSchool] = useState(preloaded || null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (preloaded) return;
    setSchool(null);
    setStatus(null);
    axios.get(`${API}/sites/${encodeURIComponent(slug)}`)
      .then(({ data }) => setSchool(data))
      .catch((e) => { applyBrand(null); setStatus(STATUS[e.response?.status] || "error"); });
  }, [slug, preloaded]);

  if (status) return <SiteStatus kind={status} slug={slug} />;
  if (!school) return <div className="min-h-screen" />;
  return (
    <ConfigProvider initial={school.config} slug={school.slug}>
      <Landing />
    </ConfigProvider>
  );
}
